//#region Selectable dropdown

var selectableDropdown = {
    getSelectedValues($kdrDdlCustom) {
        let v = $kdrDdlCustom.data('selectedValues')
        return (undefined == v || null == v) ? [] : v
    },
    /**
     * Setting data of selected value, based od rendered items.
     * @param {any} $kdrDdlCustom
     * @param {any} callback
     */
    setSelectedValues($kdrDdlCustom, callback) {
        let selectedValues = []

        $kdrDdlCustom.find('.kdr-ddl-custom-item').each(function (i, e) {
            let value = $(e).data('value')
            if (value != undefined && value !== '') {
                selectedValues.push(value)
            }
        })

        //$this.data({ selectedValues: selectedValues })
        $kdrDdlCustom.data('selectedValues', selectedValues)

        callback && callback()
    },
    /**
     * Rendering new item(s) 
     * @param {any} $kdrDdlCustom
     * @param {any} value single value or array of values
     */
    renderNewItem($kdrDdlCustom, value) {
        if ($.isArray(value)) {
            $(value).each((a, b) => selectableDropdown.renderNewItem($kdrDdlCustom, b))
        } else {

            let $selectedItem = $kdrDdlCustom.find('.kdr-dropdown-w-search-item[data-value="' + value + '"]')
            let selectedItemTitile = $selectedItem.find('.kdr-dropdown-w-search-item-text').text()

            let $copiedTr = $kdrDdlCustom
                .find('.kdr-ddl-custom-tr-pattern')
                .clone()
                .detach()

            $copiedTr.find('.kdr-ddl-custom-item')
                .text(selectedItemTitile)
                .data('value', value)

            $copiedTr.find(tooltipOtions.selector).tooltip({
                delay: {
                    show: tooltipOtions.delay.show,
                    hide: tooltipOtions.delay.hide
                },
                boundary: tooltipOtions.boundary,
                trigger: tooltipOtions.trigger,
            })

            $copiedTr
                .insertBefore($selectedItem.closest('.kdr-ddl-custom-tr-select'))
                .removeClass('hide')
                .removeClass('kdr-ddl-custom-tr-pattern')
                .addClass('kdr-ddl-custom-tr')
        }
    },
    /**
     * Rendering and setting up new array of selected values.
     * @param {any} $kdrDdlCustom
     * @param {any} values
     */
    selectValuesWPurge($kdrDdlCustom, values) {
        selectableDropdown.removeAllItems($kdrDdlCustom)
        selectableDropdown.renderNewItem($kdrDdlCustom, values)
        selectableDropdown.setSelectedValues($kdrDdlCustom)
    },
    /**
     * Removing all selected items and setting up selected values to empty array.
     * @param {any} $kdrDdlCustom
     */
    removeAllItems($kdrDdlCustom) {
        $kdrDdlCustom.find('.kdr-ddl-custom-tr').remove()
        selectableDropdown.setSelectedValues($kdrDdlCustom)
    },
}
$(function () {

    $(document).on('collectItems', '.kdr-ddl-custom.table', function (e, callback) {
        selectableDropdown.setSelectedValues($(this), callback)
    })

    $(document).on('addItem', '.kdr-ddl-custom-select', function () {
        let $this = $(this)
        let $selectedItem = $this
        let selectedItemValue = $selectedItem.data('value')
        if (selectedItemValue != undefined && selectedItemValue != null && selectedItemValue !== '') {

            let $kdrDdlCustom = $this.closest('.kdr-ddl-custom')
            let maxItemsToSelect = $kdrDdlCustom.data('maxitemstoselect')
            let selectedValues = $kdrDdlCustom.data('selectedValues')
            let isAllowedMultiSelection = $kdrDdlCustom.data('isallowedmultiselection')

            if (selectedValues == undefined) {
                $kdrDdlCustom.trigger('collectItems')
                $this.trigger('addItem')
                return
            }

            //validation START
            if (maxItemsToSelect != undefined && selectedValues != undefined && selectedValues.length >= maxItemsToSelect) {
                modal.getModal.danger(__l.Error, "~{You can select only !{" + maxItemsToSelect + "} items.}", true)

                return
            }
            else if (isAllowedMultiSelection != undefined
                && !$.parseJSON(isAllowedMultiSelection.toLowerCase())
                && selectedValues.some(function (x) { return x == selectedItemValue })) {

                modal.getModal.danger(__l.Error, "~{You can select this item only once.}", true)

                return
            }
            //validation END

            selectableDropdown.renderNewItem($kdrDdlCustom, selectedItemValue)


            $this.closest('.kdr-ddl-custom.table').trigger('collectItems')
        }
    })

    //$(document).on('click', '.kdr-ddl-custom-select option', function (e) {
    //    $(this).closest('.kdr-ddl-custom-select').change()
    //})

    $(document).on('change', '.kdr-ddl-custom-select', function () {
        $(this).closest('.kdr-ddl-custom-select').trigger('addItem')
    })

    $(document).on('click', '.kdr-ddl-custom-btn-delete', function () {
        let $clearParent = $(this).closest('.clear-parent-ddl');
        if ($clearParent.length) {
            let $selectedRow = $clearParent.find('.kdr-ddl-custom-tr-select');
            if ($selectedRow.length) {
                let $menu = $selectedRow.find('.kdr-dropdown-w-search-menu');
                if ($menu.length) {
                    let $item = $menu.find('.kdr-dropdown-w-search-item[tabindex="1"]');
                    if ($item.length) {
                        $item.click()
                    }
                }
            }
        }

        let $table = $(this).closest('.kdr-ddl-custom.table')
        $(this).tooltip('hide')
        $(this).closest('tr').remove()
        $table.trigger('collectItems')

    })

    $(document).on('click', '.kdr-ddl-custom-btn-m-up', function () {
        let $tr = $(this).closest('.kdr-ddl-custom-tr')

        $tr.addClass('moving')
        $tr.find(tooltipOtions.selector).tooltip('hide')
        $tr.prev('tr').insertAfter($tr)

        $(this).blur()
        $(this).closest('.kdr-ddl-custom.table').trigger('collectItems')
        setTimeout(function () { $tr.removeClass('moving') }, 250)
    })

    $(document).on('click', '.kdr-ddl-custom-btn-m-down', function () {
        let $tr = $(this).closest('.kdr-ddl-custom-tr')

        $tr.addClass('moving')
        $tr.find(tooltipOtions.selector).tooltip('hide')
        $tr.next('tr').not('.kdr-ddl-custom-tr-select').insertBefore($tr)

        $(this).blur()
        $(this).closest('.kdr-ddl-custom.table').trigger('collectItems')
        setTimeout(function () { $tr.removeClass('moving') }, 250)
    })
})

//#endregion Selectable dropdown